//codex-- Accessible shortcuts with separate personal and company groups.
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { BookmarkIcon } from '@heroicons/react/24/outline';
import BookmarkSiteIcon from './BookmarkSiteIcon';
import { Link } from 'react-router-dom';
import { useBookmarks } from '../context/Bookmarks';
import { bookmarkTarget } from '../utils/bookmarks';
export default function BookmarksMenu() {
  const { personal, company, loading, error, refresh } = useBookmarks();
  return <Menu as="div" className="relative">{({ open }) => <>
    <Menu.Button onClick={() => { if (!open) refresh(); }} className="rounded-full p-2 text-gray-300 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
      <span className="sr-only">Open bookmarks</span><BookmarkIcon className="h-6 w-6" aria-hidden="true" />
    </Menu.Button>
    <Transition as={Fragment} enter="transition duration-100" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="transition duration-75" leaveFrom="opacity-100" leaveTo="opacity-0">
      <Menu.Items className="absolute right-0 z-50 mt-2 max-h-[70vh] w-72 max-w-[calc(100vw-2rem)] overflow-y-auto rounded-xl bg-white py-2 shadow-lg ring-1 ring-black/10 focus:outline-none">
        {loading && <p role="status" className="px-4 py-2 text-sm text-gray-500">Loading bookmarks…</p>}
        {error && <div role="alert" className="px-4 py-2 text-sm text-red-600">{error}<button type="button" onClick={refresh} className="ml-2 underline">Retry</button></div>}
        {[['My Bookmarks', personal], ['IRL Links', company]].map(([title, items]) => <div key={title} className="border-b border-gray-100 pb-2">
          <p className="px-4 pb-1 pt-3 text-xs font-semibold uppercase tracking-wide text-gray-500">{title}</p>
          {!items.length && !loading && <p className="px-4 py-2 text-sm text-gray-500">No bookmarks yet.</p>}
          {items.map((item) => {
            const target = bookmarkTarget(item.link);
            if (!target) return null;
            const content = <><BookmarkSiteIcon link={item.link} /><span className="break-words">{item.label}</span></>;
            return <Menu.Item key={item.id}>{({ active }) => target.external
              ? <a href={target.href} target="_blank" rel="noopener noreferrer" className={`flex items-center gap-2 px-4 py-2 text-sm text-gray-700 ${active ? 'bg-indigo-50' : ''}`}>{content}</a>
              : <Link to={target.href} className={`flex items-center gap-2 px-4 py-2 text-sm text-gray-700 ${active ? 'bg-indigo-50' : ''}`}>{content}</Link>}
            </Menu.Item>;
          })}
        </div>)}
        <Menu.Item>{({ active }) => <Link to="/system_config/bookmarks" className={`block px-4 py-3 text-sm font-semibold text-indigo-600 ${active ? 'bg-indigo-50' : ''}`}>Manage bookmarks</Link>}</Menu.Item>
      </Menu.Items>
    </Transition>
  </>}</Menu>;
}
